module.exports = __webpack_public_path__ + "static/img/ourCulture.dc71f08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUs/ourCulture.jpg
// module id = ze9z
// module chunks = 1